import LogsPage from './LogsPage';

export default LogsPage;


// WEBPACK FOOTER //
// ./src/features/log/pages/logs-page/index.js